import script from "./PaySheet.vue?vue&type=script&setup=true&lang=js"
export * from "./PaySheet.vue?vue&type=script&setup=true&lang=js"

import "./PaySheet.vue?vue&type=style&index=0&id=bc5cf474&scoped=true&lang=less"
import "./PaySheet.vue?vue&type=style&index=1&id=bc5cf474&lang=less"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc5cf474"]])

export default __exports__